import React, {useCallback, useState, useEffect} from "react";
import {useDropzone} from 'react-dropzone'
import "./UploadPhoto.scss"
import imgVector from './img/duplicate-cuate.svg'
import {RaikoGridOneColumn, RaikoLabel, showWarningMessage} from "@moeindal/base-raiko-panel-components";

const UploadPhoto = (
    {
        photo = [],
        setPhoto,
        setPhotoFile,
        isSingleSelect = true,
        maxSize = 1024 * 1000
    }) => {


    const [files, setFiles] = useState([]);

    useEffect(() => {
        setPhotoFile(files)
    }, [files]);


    const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
        if (acceptedFiles?.length) {
            if (isSingleSelect) {
                setFiles([])
                setPhoto([])
                setFiles(
                    [Object.assign(acceptedFiles[0], {preview: URL.createObjectURL(acceptedFiles[0])})]
                )
            } else {
                setFiles(prevFiles => [
                    ...prevFiles,
                    ...acceptedFiles.map(file =>
                        Object.assign(file, {preview: URL.createObjectURL(file)}))
                ])
            }
        }
        if (rejectedFiles.length > 0) {
            showWarningMessage(`حداکثر حجم فایل انتخابی می بایست ${maxSize / 1024000} مگابایت باشد`)
        }

    }, [])
    const {getRootProps, getInputProps, isDragActive} = useDropzone(
        {
            onDrop
            , accept: {
                'image/png': ['.png'],
                'image/jpeg': ['.jpeg'],
                'image/jpg': ['.jpg'],
            },
            maxSize: maxSize
        })

    function handleDeleteImageFromList(fileIndex) {
        const _files = files
        setFiles([])

        _files.map((file, index) => {
            if (index !== fileIndex) {
                setFiles(prev => [
                    ...prev,
                    file
                ])
            }
        })
    }

    function handleDeleteImageFromPhotoList(photoIndex) {
        const _files = photo
        setPhoto([])

        _files.map((file, index) => {
            if (index !== photoIndex) {
                setFiles(prev => [
                    ...prev,
                    file
                ])
            }
        })
    }

    return (
        <section className={"baseUploadPhotoSectionContainer"}>
            <RaikoGridOneColumn>
                <RaikoLabel text={"| بارگزاری فایل"}/>

                <div {...getRootProps({
                    className: "baseUploadPhotoContainer"
                })}>
                    <img src={imgVector} alt=""/>
                    <input {...getInputProps()} />
                    {
                        isDragActive ?
                            <p>فایل را اینجا رها کنید...</p> :
                            <p>فایل مورد نظر را اینجا بکشید و یا برای انتخاب فایل کلیک نمایید</p>
                    }
                </div>
            </RaikoGridOneColumn>
            <RaikoGridOneColumn>
                <RaikoLabel text={"| فایل های انتخاب شده"}/>
                <div className={"previewContainer"}>
                    {
                        files && files.length > 0 ?
                            files.map((file, index) => {
                                return <div className={"imageContainer"}>
                                    <div className={"deleteIconContainer"}
                                         onClick={_ => handleDeleteImageFromList(index)}>
                                        <div className={"trash-icon"}/>
                                    </div>
                                    <img src={file.preview} alt=""/>
                                </div>
                            })
                            :
                            ""
                    }
                    {
                        photo && photo.length > 0 ?
                            photo.map((file, index) => {
                                return <div className={"imageContainer"}>
                                    <div className={"deleteIconContainer"}
                                         onClick={_ => handleDeleteImageFromPhotoList(index)}>
                                        <div className={"trash-icon"}/>
                                    </div>
                                    <img src={file} alt=""/>
                                </div>
                            })
                            :
                            ""
                    }
                    {
                        files.length === 0 && photo.length === 0 ?
                            <div className={"notFoundMessageContainer"}>
                                <p>هنوز هیچ فایلی انتخاب نشده است.</p>
                            </div> : ""
                    }
                </div>
            </RaikoGridOneColumn>
        </section>
    )
}
export default UploadPhoto